import { useEffect, useState } from "react";
import Seo from "@/lib/Seo";
import { api } from "@/lib/api";
import Reveal from "@/components/Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function Faq() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/public/faq").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <>
      <Seo title="FAQ" path="/faq"
        description="Questions fréquentes sur Douzième Homme — Le Jeu : joueurs, âge, durée, application compagnon, livraison et retours." />
      <section className="py-14 sm:py-20" data-testid="faq-page">
        <div className="container-x max-w-3xl">
          <Reveal className="mb-12">
            <p className="eyebrow mb-4">Questions fréquentes</p>
            <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight uppercase leading-[1.05] text-onyx">
              Tout ce qu'on nous demande.
            </h1>
          </Reveal>
          {items === null ? (
            <p className="text-muted-foreground">Chargement…</p>
          ) : (
            <Reveal>
              <Accordion type="single" collapsible className="bg-white border border-line px-6" data-testid="faq-accordion">
                {items.map((item) => (
                  <AccordionItem key={item.id} value={item.id} className="border-line">
                    <AccordionTrigger data-testid={`faq-q-${item.id}`} className="text-left font-display font-bold text-onyx hover:text-rouge text-base sm:text-lg">
                      {item.question}
                    </AccordionTrigger>
                    <AccordionContent data-testid={`faq-a-${item.id}`} className="text-muted-foreground leading-relaxed text-sm sm:text-base">
                      {item.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          )}
        </div>
      </section>
    </>
  );
}
